export const SEARCHBAR_ENABLED = 'search-enabled'
export const REAL_BREADCRUMB_ENABLED = 'real-breadcrumb-enabled'
export const HUBSPOT_PLUS_FORMS = 'hubspot-plus-forms'
export const HUBSPOT_PLUS_FORMS_FOR_DTC_ENABLED =
  'hubspot-plus-forms-for-dtc-enabled'
export const EDIT_ACCOUNT_DETAILS_FORM_ENABLED = 'edit-account-details'
export const REORDER_FLOW_UPDATES_ENABLED = 'in-cart-quantity-editing-enabled'
export const UNIFIED_ORDER_PROCESSING = 'unified-order-processing'
export const APP_ROUTER_CATALOG_PAGES = 'app-router-catalog-pages'
export const CHANNEL_BASED_CATALOG = 'channel-based-catalog'
